export const uiSchema = (t: Function, editing: boolean) => {
  const id = {
    "ui:disabled": true,
    "ui:options": {
      labelposition: "top",
    },
  };

  if (!editing) {
    id["ui:widget"] = "hidden";
  }

  return {
    "ui:order": [
      "id",
      "name",
      "lengthScope",
      "creation_rule",
      "absence_type_scope",
      "eligibility_rule",
      "is_active",
      "manager_can_change_reason",
      "*",
    ],
    id,
    creationRule: {
      "ui:widget": "hidden",
    },
    eligibilityRule: {
      "ui:widget": "hidden",
    },
    lengthScope: {
      "ui:widget": "number-input",
    },
    isActive: {
      "ui:title": "Status",
      "ui:widget": "toggle",
      "ui:options": {
        labels: [
          { label: t("ACTIVE"), value: true },
          { label: t("INACTIVE"), value: false },
        ],
      },
    },
    managerCanChangeReason: {
      "ui:widget": "hidden",
      "ui:options": {
        labels: [
          { label: t("CAN_CHANGE"), value: true },
          { label: t("CANNOT_CHANGE"), value: false },
        ],
      },
    },
    absenceReasons: {
      "ui:widget": "hidden",
    },
  };
};
